export const ADD_CUSTOM_LICENSE = "add_custom_license";
export const ADD_CUSTOM_LICENSE_SUCCESSFUL = "add_custom_license_successful";
export const ADD_CUSTOM_LICENSE_FAILURE = "add_custom_license_failure";

export const GET_CUSTOM_LICENSES = "get_custom_licenses";
export const GET_CUSTOM_LICENSES_SUCCESSFUL = "get_custom_licenses_successful";
export const GET_CUSTOM_LICENSES_FAILURE = "get_custom_licenses_failure";

export const UPDATE_CUSTOM_LICENSE = "update_custom_license";
export const UPDATE_CUSTOM_LICENSE_SUCCESSFUL = "update_custom_license_successful";
export const UPDATE_CUSTOM_LICENSE_FAILURE = "update_custom_license_failure";

export const DELETE_CUSTOM_LICENSE = "delete_custom_license";
export const DELETE_CUSTOM_LICENSE_SUCCESSFUL = "delete_custom_successful";
export const DELETE_CUSTOM_LICENSE_FAILURE = "delete_custom_failure";

export const CLEAR_ALL_MESSAGES = "clear_all_messages";
export const CLEAR_ALL_MESSAGES_SUCCESS = "clear_all_messages_success";

export const CLEAR_SUCCESS_MESSAGES = "clear_success_messages";
export const CLEAR_SUCCESS_MESSAGES_SUCCESS = "clear_success_messages_success";

export const CLEAR_FAILURE_MESSAGES = "clear_failure_messages";
export const CLEAR_FAILURE_MESSAGES_SUCCESS = "clear_failure_messages_success";
